import React, { useRef, useState, useEffect } from 'react'
import { Form, Card, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { Link, useHistory } from 'react-router-dom';
import CenteredContainer from './CenteredContainer';

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const {login} = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { currentUser } = useAuth();

useEffect(() => { 
  if(currentUser){
    if(currentUser.role === 'admin'){
      history.push('/admin');
    }else{
      history.push('/overview');
    }
  }
}, [currentUser])

async function handleSubmit(e) {
  e.preventDefault()

  try{
    setError('');
    setLoading(true);
    await login(emailRef.current.value, passwordRef.current.value);
    if(emailRef.current.value.includes('@z21studio.com')){
      history.push('/admin');
    }else{
      history.push('/overview');
    }
  } catch {
    setError('Wrong email/ password.');
  }
  setLoading(false);
}

  return (
    <CenteredContainer>
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4"> Login </h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required/>
            </Form.Group>

            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" ref={passwordRef} required/>
            </Form.Group>

            <Button disabled={loading} className="w-100 mt-4" type="submit">Login</Button>
          </Form>

        <div className="w-100 text-center mt-3">
          <Link to="/forgot-password">Forgot password?</Link>
        </div>
        </Card.Body>
      </Card>

      
    </CenteredContainer>
  )
}
